import { render, staticRenderFns } from "./permission-types.vue?vue&type=template&id=00f671a6&scoped=true"
import script from "./permission-types.vue?vue&type=script&lang=js"
export * from "./permission-types.vue?vue&type=script&lang=js"
import style0 from "./permission-types.vue?vue&type=style&index=0&id=00f671a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f671a6",
  null
  
)

export default component.exports